import React from "react";
import { useLanguage } from "../context/LanguageContext";
import "./LanguageToggle.css";

const LanguageToggle: React.FC = () => {
  const { language, toggleLanguage, t } = useLanguage();

  React.useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const lang = urlParams.get("lang");
    if (lang && lang !== language) {
      toggleLanguage();
    }
  }, [language, toggleLanguage]);

  return (
    <button
      className="language-toggle"
      onClick={toggleLanguage}
      aria-label="Toggle language"
    >
      {t(language === "he" ? "switch.to.english" : "switch.to.hebrew")}
    </button>
  );
};

export default LanguageToggle;
